import { baseCRUDAPI } from './base';

export default class Appointments extends baseCRUDAPI {
  constructor(axiosObject) {
    super(axiosObject, 'Appointment');
  }

  async getByEventId(eventId) {
    return this.axiosObject.get(
      `${this.apiBaseName}/`,
      {
        params: {
          eventId,
        },
      },
    );
  }

  async submitSession({ appointmentId, inputs, comment }) {
    return this.axiosObject.post(
      `${this.apiBaseName}/${appointmentId}/session`,
      {
        user: inputs,
        comment,
      },
    );
  }

  async getSession(id) {
    return this.axiosObject.get(`/Session/${id}`);
  }

  async getAppointment(eventId) {
    return this.axiosObject.get(
      '/Appointment/',
      {
        params: {
          eventId,
        },
      },
    );
  }

  async postSession(id, payload) {
    return this.axiosObject.post(
      `/Session/${id}/SME`,
      payload,
    );
  }

  async patchAppointmentStatus(id, smeId, payload) {
    return this.axiosObject.patch(
      `/Appointment/${id}/Session/${smeId}`,
      payload,
    );
  }

  async patchSession(id, smeId, payload) {
    return this.axiosObject.patch(
      `/Session/${id}/SME/${smeId}`,
      payload,
    );
  }

  async deleteSession(id) {
    return this.axiosObject.delete(`/Session/${id}`);
  }

  async deleteSMESession(id, smeId) {
    return this.axiosObject.delete(`/Session/${id}/SME/${smeId}`);
  }
}
